import { observer } from 'mobx-react-lite'
import { Divider, PhoneWithLabelInput, TextFieldWithLabel } from 'shared/ui'
import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import { makeTextFieldIcon } from 'shared/ui/TextField'
import { useRcsWizardContext } from 'pages/settings/pages/rcsV2/context/rcsWizardContext'

import styles from '../styles.module.scss'

export const BusinessDetailsFields = observer(() => {
  const {
    businessInfoStore: {
      websiteUrl,
      websiteUrlError,
      websiteUrlMaxLength,
      isWebsiteUrlValid,
      setWebsiteUrl,
      validateWebsiteUrl,
      companyType,
      companyTypeError,
      companyTypeOptions,
      setCompanyType,
      businessIndustry,
      businessIndustryError,
      businessIndustryOptions,
      setBusinessIndustry,
      referencesLoading,
      loadBusinessReferences,
      isPublicCorporation,
      stockExchange,
      stockExchangeError,
      stockExchangeOptions,
      stockExchangesLoading,
      setStockExchange,
      loadStockExchanges,
      stockSymbol,
      stockSymbolError,
      setStockSymbol,
      validateStockSymbol,
      phoneStore,
    },
  } = useRcsWizardContext()

  const {
    countries,
    country,
    number,
    numberError,
    isValidNumber,
    setNumber,
    setCountry,
    triggerNumberValidation,
  } = phoneStore

  return (
    <>
      <div>
        <PhoneWithLabelInput
          label='Business contact phone number'
          isNoMarginTopInputLabel
          items={countries}
          item={country}
          number={number}
          numberError={numberError}
          isValidNumber={isValidNumber}
          setNumber={setNumber}
          setCountry={setCountry}
          triggerNumberValidation={triggerNumberValidation}
        />
      </div>

      <TextFieldWithLabel
        marginBottom={0}
        errorBorder={Boolean(websiteUrlError)}
        errorMessage={websiteUrlError}
        limit={websiteUrlMaxLength}
        labelProps={{
          label: { text: 'Business website URL' },
          questionTooltipProps: {
            type: 'description',
            width: 240,
            label: 'You need a website to register',
          },
        }}
        textFieldProps={{
          size: 'medium',
          value: websiteUrl,
          onChange: setWebsiteUrl,
          onBlur: validateWebsiteUrl,
          InputProps: { placeholder: 'e.g. https://www.example.com/' },
        }}
        rightActions={[
          makeTextFieldIcon({
            icon: isWebsiteUrlValid ? 'check2' : undefined,
            fontSize: 16,
            color: 'var(--green-60)',
          }),
        ]}
      />

      <Divider
        sx={{
          marginTop: '11px',
          marginBottom: '4px',
          borderColor: 'var(--border-neutral-default)',
        }}
      />

      <div className={styles.row}>
        <div className={styles.rowItem}>
          <SelectField
            size='medium'
            labelProps={{ label: { text: 'Company type' } }}
            placeholder='Select'
            items={companyTypeOptions}
            loading={referencesLoading}
            value={companyType}
            setValue={setCompanyType}
            error={companyTypeError}
            dropdownProps={{ onToggle: (open) => open && loadBusinessReferences() }}
          />
        </div>
        <div className={styles.rowItem}>
          <SelectField
            size='medium'
            labelProps={{ label: { text: 'Business industry' } }}
            placeholder='Select'
            items={businessIndustryOptions}
            loading={referencesLoading}
            value={businessIndustry}
            setValue={setBusinessIndustry}
            error={businessIndustryError}
            dropdownProps={{ onToggle: (open) => open && loadBusinessReferences() }}
          />
        </div>
      </div>

      {isPublicCorporation && (
        <div className={styles.row}>
          <div className={styles.rowItem}>
            <SelectField
              size='medium'
              labelProps={{ label: { text: 'Stock exchange' } }}
              placeholder='Select'
              items={stockExchangeOptions}
              loading={stockExchangesLoading}
              value={stockExchange}
              setValue={setStockExchange}
              error={stockExchangeError}
              dropdownProps={{ onToggle: (open) => open && loadStockExchanges() }}
            />
          </div>
          <div className={styles.rowItem}>
            <TextFieldWithLabel
              marginBottom={0}
              widthWrap='100%'
              errorBorder={Boolean(stockSymbolError)}
              errorMessage={stockSymbolError}
              labelProps={{ label: { text: 'Company Stock Ticker Symbol' } }}
              textFieldProps={{
                size: 'medium',
                value: stockSymbol,
                onChange: setStockSymbol,
                onBlur: validateStockSymbol,
                InputProps: { placeholder: 'e.g. AAPL' },
              }}
            />
          </div>
        </div>
      )}
    </>
  )
})
